<template>
  <layout>
    <page-header :actions="actions" :header="$t('vehicles.vehicle_types.title')" />
    <div class="content">
      <admin-table ref="table" v-bind="tableProps">
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import VehicleTypeApi from './Api'

const resourceBase = 'vehicle-types'

export default {
  name: 'VehicleType',

  components: {
    AdminTable,
  },

  data() {
    return {
      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder: () => {
          return new VehicleTypeApi()
        },
        sortBy: 'order',
        sortDesc: false,
        perPage: 9,
        columns: [
          {
            key: 'name',
            label: this.$t('vehicles.vehicle_types.name'),
            sortable: true,
          },
          {
            key: 'description',
            label: this.$t('vehicles.vehicle_types.description'),
            sortable: true,
          },
        ],

        // define custom row actions
        // eslint-disable-next-line no-unused-vars
        rowActions: item => {
          let actions = []

          if (this.$allows('administer')) {
            actions.push('edit')
          }
          if (this.$allows('administer')) {
            actions.push({
              label: this.$t('general.delete'),
              variant: 'warning', // BS button variants
              handler: async () => {
                // prettier-ignore
                const { value: ok } = await this.$alert.question(this.$t('vehicles.vehicle_types.messages.delete_question'), '', {
                    showCancelButton: true,
                  },
                )

                if (ok) {
                  try {
                    await new VehicleTypeApi().destroy(item.id)
                    this.$refs.table.refresh()
                  } catch (err) {
                    if (err.status === 400) {
                      this.$alert.error(
                        this.$t('vehicles.vehicle_types.messages.delete_error'),
                      )
                    } else {
                      this.$toast.error(err.message)
                    }
                  }
                }
              },
            })
          }

          return actions
        },

        // define custom bulk actions
        bulkActions: () => {
          return []
        },
      },
    }
  },

  computed: {
    // Page header actions
    actions() {
      if (this.$allows('administer')) {
        return [
          {
            id: 'create',
            text: this.$t('general.add_new'),
            icon: 'icon-plus-circle2',
            onClick: () => {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.$router.push({
                name: `${resourceBase}.create`,
              })
            },
          },
        ]
      } else {
        return []
      }
    },
  },
}
</script>

<style lang="scss">
.min-w-60 {
  min-width: 90px !important;
}
</style>
